import { StylesConfig } from 'react-select';

export const SelectCustomStyles: StylesConfig = {
  control: (provided: Record<string, unknown>, state: any) => ({
    ...provided,
    border: state.isFocused ? '1px solid #344bc6' : '1px solid #e0e0e0',
    boxShadow: state.isFocused ? '0px 0px 2px #344bc6' : 'none',
    '&:hover': {
      border: '1px solid #344bc6',
      boxShadow: '0px 0px 2px #344bc6',
    },
    input: {
      boxShadow: 'none',
      border: 'none',
    },
  }),
  option: (styles, state) => ({
    ...styles,
    backgroundColor: state.isSelected ? '#344bc6' : 'none',
  }),
  singleValue: (styles) => ({
    ...styles,
    overflow: 'visible', // Make overflow visible on the single value
  }),
};
